<template>
  <div class="register-img">
    <img :src="imgs" alt />
  </div>
</template>

<script>
export default {
  name: "registerImg",
  props: ["imgs"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.register-img {
  width: 100%;
  min-width: 1040px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/common/herder-img.vue